import {useEffect, useState, useCallback} from 'react'

import Display from './browse/display';

import {ProceedButton} from '../../buttons';

import '@uppy/image-editor/dist/style.css'
import axios from 'axios';

import FileTypes from '../../../lib/files/file-types';
import LoadingIcon from "../../ui/loading-icon";

const FileIcons = {
    'application/pdf': 'pdf',
    'application/msword': 'document-icon',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'document-icon',
    'text/plain': 'txt',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'text/csv': 'csv',
    'image/jpeg' : 'document-icon',
    'image/png' : 'document-icon'
}

export default ({onResourceSelect, path, readOnly}) => {
    const [files, setFiles] = useState([]);
    const [selected, setSelected] = useState(null);
    const [busy, setBusy] = useState(true);

    const onSelect = (item) => {
        if (item.id == selected?.id) return setSelected(null);

        setSelected(item);
    }

    useEffect(() => {

        if(window.grantsPreview === true) {
            setBusy(false);
            setFiles([{
                id: Math.random(200, 300),
                application_id : Math.random(1, 100).toString(),
                file_id : Math.random(1, 100),
                question_id : null,
                file : {
                    mime_type : 'application/pdf',
                    name : 'Test file'
                }
            }]);

        }else {

            axios.post('/api/connector/call', {
                path: path,
                method: 'get',
            }).then((response) => {
                const {data} = response.data;

                setTimeout(() => {
                    setBusy(false);

                }, 500);
                setFiles(data)
            })
        }

    }, []);

    return (
        <div class="images-browse">
            <div class="images-browse__section">
                <div className="images-browse__outer">
                    <div class="images-browse__list">
                        {
                            busy === false &&
                            <>
                            {
                                Array.isArray(files) && files.map((obj) => {
                                    const item = obj.file;

                                    const className = "images-item " + (obj.id == selected?.id ? 'images-item--selected' : '')

                                    const name = item.name.split('.');
                                    const fileName = name[0].slice(0, 12) + '.' + name[name.length - 1];

                                    return (
                                        <div class={className} onClick={() => onSelect(obj)}>
                                            <img src={`/assets/file-types/${FileIcons[item.mime_type]}.svg`} />
                                            <div class="images-item__select">
                                                {obj.id == selected?.id ? 'Selected' : fileName}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                                {
                                    Array.isArray(files) && files.length === 0 &&
                                        <div className={'images-browse__empty'}>
                                            Nothing uploaded yet, click 'Upload' to add files
                                        </div>
                                }
                            </>

                        }
                        {
                            busy === true &&
                            <div className={'images-browse__loading'}>
                                <LoadingIcon />
                            </div>
                        }

                    </div>
                </div>
            </div>
            { selected !== null && <div class="images-browse__box">
                <Display img={selected.file} icon={`/assets/file-types/${FileIcons[selected.file.mime_type]}.svg`} readOnly={readOnly} onUseResource={() => onResourceSelect(selected)}/>
            </div>}
            {/* <div className="images-browse__bottom">
                { selected !== null && <ProceedButton>Use selected file</ProceedButton> }
            </div> */}
        </div>
    )
}

